import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS - 3);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: hours,
    suffix: 'hrs'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-brand text-white" data-id="element-33" data-mp="ant8i1dy1vw4">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-1 text-[10px] font-bold uppercase leading-none tracking-[0.14em] sm:text-[11px]" data-id="element-34" data-mp="6nit5y49ht4l">
        <HourglassIcon className="h-3 w-3" aria-hidden="true" data-id="element-35" data-mp="13g3mnidrv9p3" />
        <span data-id="element-36" data-mp="18dwqw5viltmq">Launch offer ends in:</span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-37" data-mp="18ar26rqsstrj">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1" data-id="element-38" data-mp="yeo35ur8tb8t" data-mpi={index}>
              <span className="text-xs font-extrabold sm:text-sm" data-id="element-39" data-mp="ygqy8t795uke">
                {pad(unit.value)}
              </span>
              <span className="text-[9px] tracking-normal opacity-90" data-id="element-40" data-mp="1r3bpzurn48oh">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="px-0.5 opacity-70" data-id="element-41" data-mp="1da3y01zndb69">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}